"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Logger = _interopRequireDefault(require("@/libs/Logger"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var _NicklistUser = _interopRequireDefault(require("./NicklistUser"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const log = _Logger.default.namespace('Nicklist');
var _default = exports.default = {
  components: {
    NicklistUser: _NicklistUser.default
  },
  props: ['network', 'buffer', 'sidebarState'],
  data() {
    return {
      self: this,
      userFilter: '',
      userFilterVisible: false
    };
  },
  computed: {
    sortedUsers() {
      // Get a list of network prefixes and give them a rank number
      const netPrefixes = this.network.ircClient.network.options.PREFIX;
      const prefixOrders = Object.create(null);
      netPrefixes.forEach((prefix, idx) => {
        prefixOrders[prefix.mode] = idx;
      });

      // A few things here:
      // * Since vuejs will sort in-place and update views when .sort is called
      //   on an array, clone it first so that we have a plain array to sort
      // * Keep a map of uppercase nicks to we don't need to call .toUpperCase()
      //   on each one all the time. This is a hot function!
      const nickMap = Object.create(null);
      const users = [];
      const bufferUsers = this.buffer.users;
      const nickFilter = this.userFilter.toUpperCase();
      Object.entries(bufferUsers).forEach(([uppercaseNick, user]) => {
        nickMap[user.nick] = uppercaseNick;
        if (!nickFilter || uppercaseNick.indexOf(nickFilter) !== -1) {
          users.push(user);
        }
      });
      const bufferId = this.buffer.id;
      const groupAway = this.$state.setting('nicklistGroupAway');
      return users.sort((a, b) => {
        const bufferA = a.buffers[bufferId];
        const bufferB = b.buffers[bufferId];
        if (!bufferA) {
          const msg = 'Nicklist.sortedUsers() User A does not have the buffer in its list!';
          log.error(msg, a.nick, a.buffers);
          return -1;
        }
        if (!bufferB) {
          const msg = 'Nicklist.sortedUsers() User B does not have the buffer in its list!';
          log.error(msg, b.nick, b.buffers);
          return 1;
        }
        const modesA = bufferA.modes;
        const modesB = bufferB.modes;

        // Neither user has a prefix, compare text
        if (modesA.length === 0 && modesB.length === 0) {
          // Compare away status
          if (groupAway) {
            if (a.away && !b.away) {
              return 1;
            }
            if (!a.away && b.away) {
              return -1;
            }
          }
          return Misc.strCompare(nickMap[a.nick], nickMap[b.nick]);
        }

        // Compare via prefixes..
        if (modesA.length > 0 && modesB.length === 0) {
          return -1;
        }
        if (modesA.length === 0 && modesB.length > 0) {
          return 1;
        }

        // Both users have a prefix so find the highest ranking one
        const aP = prefixOrders[this.buffer.userMode(a)];
        const bP = prefixOrders[this.buffer.userMode(b)];
        if (aP > bP) {
          return 1;
        } else if (aP < bP) {
          return -1;
        }

        // Prefixes are the same, compare away status
        if (groupAway) {
          if (a.away && !b.away) {
            return 1;
          }
          if (!a.away && b.away) {
            return -1;
          }
        }

        // Prefixes are the same, resort to comparing text
        return Misc.strCompare(nickMap[a.nick], nickMap[b.nick]);
      });
    },
    allUsersCount() {
      return Object.keys(this.buffer.users).length;
    },
    shouldShowAvatars() {
      return this.buffer.setting('nicklist_avatars');
    },
    useColouredNicks() {
      return this.buffer.setting('coloured_nicklist');
    }
  },
  methods: {
    openQuery(user) {
      const buffer = this.$state.addBuffer(this.buffer.networkid, user.nick);
      this.$state.setActiveBuffer(buffer.networkid, buffer.name);
      if (this.$state.ui.is_narrow) {
        this.sidebarState.close();
      }
    },
    openUserbox(user) {
      this.$state.$emit('userbox.show', user, {
        buffer: this.buffer
      });
    },
    toggleUserFilter() {
      this.userFilterVisible = !this.userFilterVisible;
      if (this.userFilterVisible) {
        this.$nextTick(() => this.$refs.user_filter.focus());
      } else {
        this.userFilter = '';
      }
    },
    onFilterBlur() {
      if (!this.userFilter.trim()) {
        this.userFilter = '';
        this.userFilterVisible = false;
      }
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["Nicklist"]
window._kiwi_exports.components.Nicklist = exports.default ? exports.default : exports;
